import { render, staticRenderFns } from "./specificationEdit.vue?vue&type=template&id=19b26f41&scoped=true"
import script from "./specificationEdit.vue?vue&type=script&lang=js"
export * from "./specificationEdit.vue?vue&type=script&lang=js"
import style0 from "./specificationEdit.vue?vue&type=style&index=0&id=19b26f41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b26f41",
  null
  
)

export default component.exports